<script setup>
import { computed } from "vue";

const props = defineProps({
  actionButtonLabel: {
    type: String,
    required: true,
  },
  hasUtrField: {
    type: Boolean,
    default: false,
  },
  popupState: {
    type: String,
    required: true,
  },
  t: {
    type: Function,
    required: true,
  },
  utrInput: {
    type: String,
    default: "",
  },
  cooldownRemaining: {
    type: Number,
    default: 0,
  },
  actionError: {
    type: String,
    default: "",
  },
});

defineEmits(["action", "update:utrInput"]);

const buttonLabel = computed(() =>
  props.cooldownRemaining > 0
    ? props.t("retryIn").replace("{{seconds}}", props.cooldownRemaining)
    : props.actionButtonLabel,
);
</script>

<template>
  <div class="panel action-panel">
    <div class="panel-head">
      <div>
        <h2 class="panel-title">
          {{ hasUtrField ? t("step3") : t("paymentInProcess") }}
        </h2>
        <p class="panel-subtitle">
          {{ hasUtrField ? t("utrHint") : t("statusWaiting") }}
        </p>
      </div>
    </div>

    <div v-if="hasUtrField" class="input-wrap">
      <input
        :value="utrInput"
        type="text"
        inputmode="numeric"
        class="utr-input"
        :class="{ 'is-invalid': actionError }"
        :placeholder="t('enterUtr')"
        :aria-invalid="actionError ? 'true' : undefined"
        @input="$emit('update:utrInput', $event.target.value)"
      />

      <transition name="action-error">
        <p v-if="actionError" class="action-error" role="alert">
          <svg
            class="action-error-icon"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" />
            <line x1="12" y1="7" x2="12" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <circle cx="12" cy="17" r="1.2" fill="currentColor" />
          </svg>
          <span>{{ actionError }}</span>
        </p>
      </transition>
    </div>

    <button
      class="btn-primary-action"
      :class="{ 'is-cooldown': cooldownRemaining > 0 }"
      :disabled="cooldownRemaining > 0"
      @click="$emit('action')"
    >
      {{ buttonLabel }}
    </button>

    <div class="status-bar">
      <template v-if="popupState === 'verifying'">
        {{ hasUtrField ? t("verificationHint") : t("verificationHintWithoutUTR") }}
      </template>
      <template v-else>
        {{ t("statusWaiting") }}
      </template>
    </div>
  </div>
</template>
